export default __webpack_public_path__ + "static/media/045-beach.e87ba38f.svg";